import { motion } from "framer-motion";

const TESTIMONIALS = [
  { name: "Rafael M.", initial: "R", color: "#7C4DFF", time: "09:42",
    msgs: ["Cara, ficou surreal! 🔥", "Levei o estudo no meu barbeiro e ele já sabia exatamente o que fazer. Meu visual mudou completamente."] },
  { name: "Juliana P.", initial: "J", color: "#C8A46A", time: "14:18",
    msgs: ["Amei demais 😍", "Descobri que meu rosto é oval e finalmente entendi quais cortes me favorecem. Valeu cada centavo!"] },
  { name: "Diego S.", initial: "D", color: "#2E7D32", time: "20:05",
    msgs: ["Melhor R$67 que gastei 👏", "Super detalhado, com as referências certinhas pra levar na cabeleireira. Recomendo!"] },
  { name: "Camila R.", initial: "C", color: "#C2185B", time: "11:27",
    msgs: ["Nem sabia que a sobrancelha e o comprimento faziam tanta diferença no meu rosto 🤩", "Consultoria de verdade!"] },
];

const Check = () => (
  <svg viewBox="0 0 16 15" className="inline w-4 h-3 ml-1 -mb-0.5" fill="#53bdeb"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"/></svg>
);

export function WhatsAppTestimonials() {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {TESTIMONIALS.map((t, i) => (
        <motion.div
          key={t.name}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: (i % 4) * 0.1 }}
          className="rounded-2xl overflow-hidden border border-white/10 bg-[#0b141a] shadow-xl"
        >
          {/* header */}
          <div className="flex items-center gap-3 bg-[#1f2c33] px-3 py-2.5">
            <div className="w-9 h-9 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ background: t.color }}>{t.initial}</div>
            <div className="leading-tight">
              <p className="text-[#e9edef] text-sm font-medium">{t.name}</p>
              <p className="text-[#8696a0] text-[11px]">online</p>
            </div>
          </div>
          {/* chat area */}
          <div
            className="px-3 py-4 space-y-2 min-h-[190px]"
            style={{ backgroundColor: "#0b141a", backgroundImage: "radial-gradient(rgba(255,255,255,0.025) 1px, transparent 1px)", backgroundSize: "16px 16px" }}
          >
            {t.msgs.map((m, j) => (
              <div key={j} className="max-w-[92%] rounded-lg rounded-tl-none bg-[#202c33] text-[#e9edef] text-[13px] leading-snug px-3 py-2 shadow">
                {m}
                {j === t.msgs.length - 1 && (
                  <span className="block text-right text-[10px] text-[#8696a0] mt-1">{t.time}<Check /></span>
                )}
              </div>
            ))}
          </div>
        </motion.div>
      ))}
    </div>
  );
}
